module.exports = __webpack_public_path__ + "img/APUA_800X460.d63ce460.jpg";